import React, { useState } from "react"; // useState to manage state (mobile menu open/close)
import { useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import logo from "../Assets/logo/bodyfriendLogo.gif";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import API_BASE_URL from "../../config/api";

const Menu = ({ className, navigateWithRefresh }) => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <ul className={className}>
      <li className={isActive("/") ? styles.active : ""}>
        <a href="/">Home</a>
      </li>
      <li className={isActive("/bodyfriend-products") ? styles.active : ""}>
        <a href="/bodyfriend-products">Bodyfriend</a>
      </li>
      <li className={isActive("/promotions") ? styles.active : ""}>
        <a href="/promotions">Promotions</a>
      </li>
      {/* Event 暂时隐藏 */}
      {/* <li className={isActive("/events") ? styles.active : ""}>
        <a href="/events">Event</a>
      </li> */}
      <li className={isActive("/about-us") ? styles.active : ""}>
        <a href="/about-us">About Us</a>
      </li>
      <li className={isActive("/FAQ") ? styles.active : ""}>
        <a href="/FAQ">FAQ</a>
      </li>
      <li className={isActive("/contact-us") ? styles.active : ""}>
        <a href="/contact-us">Contact Us</a>
      </li>
      <li className={isActive("/product-trial") ? styles.active : ""}>
        <a href="/product-trial">Product Trial</a>
      </li>
      <li className={isActive("/store") ? styles.active : ""}>
        <a href="/store">Our Store</a>
      </li>
    </ul>
  );
};

const Navbar = () => {
  const [mobileMenuState, setMobileMenuState] = useState(""); // "" | "open" | "close"
  const [isSearchOpen, setSearchOpen] = useState(false); // manage search box state
  const [searchQuery, setSearchQuery] = useState(""); // manage search query
  const [searchResults, setSearchResults] = useState([]); // store search results

  // Navigate with a page refresh
  const navigateWithRefresh = (path) => {
    window.location.href = path;
  };

  // Toggle the state of the mobile menu
  const toggleMobileMenu = () => {
    if (mobileMenuState === "open") {
      setMobileMenuState("close");
      setTimeout(() => setMobileMenuState(""), 300); // Reset after animation
    } else {
      setMobileMenuState("open");
    }
  };

  // Toggle the search box
  const toggleSearchBox = () => {
    if (isSearchOpen === "open") {
      setSearchOpen("close");
      setTimeout(() => setSearchOpen(""), 300); // Reset state after animation
    } else {
      setSearchOpen("open");
    }
  };

  // Handle search query input
  const handleSearchChange = async (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    // fetch result dynamically
    if (query.trim()) {
      try {
        const response = await fetch(
          `${API_BASE_URL}/searchNavbar.php?query=${query}`
        );
        const results = await response.json();
        setSearchResults(results); // store results in state
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    } else {
      setSearchResults([]); // clear results if input is empty
    }
  };

  // close the search box by clicking the overlay
  const closeSearchBox = () => {
    setSearchOpen(false);
  };

  const getProductImage = (imageGif) => {
    try {
      return require(`../../Components/Assets/productGif/${imageGif}`);
    } catch (err) {
      console.error("Image not found:", imageGif);
      return null;
    }
  };

  return (
    <div className={styles.navbar}>
      {/* Hamburger Icon */}
      <div className={styles.nav_hamburger} onClick={toggleMobileMenu}>
        {mobileMenuState === "open" ? <CloseIcon /> : <MenuIcon />}
      </div>

      <div className={styles.nav_logo} onClick={() => navigateWithRefresh("/")}>
        <img src={logo} alt="Bodyfriend Logo" />
      </div>

      {/* Desktop Menu */}
      <Menu
        className={styles.navMenu}
        navigateWithRefresh={navigateWithRefresh}
      />

      {/* Mobile Menu */}
      <Menu
        className={`${styles.navMenuMobile} ${
          mobileMenuState === "open"
            ? styles.navMenuMobileOpen
            : mobileMenuState === "close"
            ? styles.navMenuMobileClose
            : ""
        }`}
        navigateWithRefresh={navigateWithRefresh}
      />

      {/* search icon */}
      <div className={styles.nav_icons}>
        <SearchIcon style={{ fontSize: 28 }} onClick={toggleSearchBox} />
      </div>

      {/* Search Box and Overlay */}
      <>
        <div
          className={`${styles.overlay} ${
            isSearchOpen ? styles.overlayVisible : styles.overlayHidden
          }`}
          onClick={closeSearchBox}
        ></div>
        <div
          className={`${styles.search_box} ${
            isSearchOpen === "open"
              ? styles.visible
              : isSearchOpen === "close"
              ? styles.hidden
              : ""
          }`}
        >
          <div className={styles.searchClose}>
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <CloseIcon
              className={styles.close_icon}
              onClick={toggleSearchBox}
            />
          </div>
          <div className={styles.search_results}>
            <h4>Search Results</h4>
            {searchResults.length > 0 ? (
              <ul>
                {searchResults.map((result, index) =>
                  result.type === "product" ? (
                    <li key={index}>
                      <a href={`/productDetails/${result.id}`}>
                        {getProductImage(result.image_gif) ? (
                          <img
                            src={getProductImage(result.image_gif)}
                            alt={result.title}
                          />
                        ) : (
                          <p>No Image</p>
                        )}
                        <div>
                          <h5>{result.title}</h5>
                          {/* <p>${result.price}</p> */}
                        </div>
                      </a>
                    </li>
                  ) : null
                )}
              </ul>
            ) : (
              <p className={styles.no_results}>No products found</p>
            )}
          </div>
        </div>
      </>
    </div>
  );
};

export default Navbar;